const paths = {
  bold: "M6 4h6a4 4 0 0 1 0 8H6z M6 12h8a4 4 0 0 1 0 8H6z",
  bringForward: "M8 3h13v13H8z M8 8H3v13h13v-5",
  centre: "M12 3v3 M12 10v4 M12 18v3 M7 6h10v4H7z M4 14h16v4H4z",
  delete: "M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7",
  duplicate: "M9 9h12v12H9z M5 15H3V3h12v2",
  edit: "M16 3l5 5-12 12-6 1 1-6L16 3z M13 6l5 5",
  ellipse: "M21 12a9 7 0 1 1-18 0 9 7 0 1 1 18 0z",
  fit: "M8 3H3v5 M16 3h5v5 M21 16v5h-5 M8 21H3v-5",
  image: "M3 3h18v18H3z M3 16l5-5 4 4 4-5 5 6 M8 7h.01",
  italic: "M19 4h-9 M14 20H5 M15 4 9 20",
  line: "M4 19 20 5",
  page: "M5 3h9l5 5v13H5z M14 3v5h5",
  qrCode:
    "M4 4h6v6H4z M14 4h6v6h-6z M4 14h6v6H4z M14 14h2v2h-2z M18 18h2v2h-2z M14 19h1 M19 14h1",
  settings:
    "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6z M12 2v3 M12 19v3 M4.9 4.9 7 7 M17 17l2.1 2.1 M2 12h3 M19 12h3 M4.9 19.1 7 17 M17 7l2.1-2.1",
  analytics: "M4 20V4 M4 20h16 M8 16v-4 M12 16V8 M16 16v-6",
  rectangle: "M3 6h18v12H3z",
  redo: "M15 4l5 5-5 5 M20 9H10a6 6 0 0 0 0 12",
  reload: "M20 4v6h-6 M20 10a8 8 0 1 0 0 5",
  save: "M3 3h14l4 4v14H3V3z M7 3v6h9V3 M7 21v-8h10v8",
  sendBackward: "M3 8h13v13H3z M8 8V3h13v13h-5",
  text: "M5 7V5h14v2 M12 5v14 M9 19h6",
  underline: "M6 3v8a6 6 0 0 0 12 0V3 M4 21h16",
  undo: "M9 4 4 9l5 5 M4 9h10a6 6 0 0 1 0 12",
  zoomIn: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M15 15l6 6 M7 10h6 M10 7v6",
  zoomOut: "M10 3a7 7 0 1 0 0 14 7 7 0 0 0 0-14z M15 15l6 6 M7 10h6",
} as const;

export type ButtonIconName = keyof typeof paths;

export function buttonIcon(name: ButtonIconName): SVGSVGElement {
  const namespace = "http://www.w3.org/2000/svg";
  const icon = document.createElementNS(namespace, "svg");
  icon.setAttribute("class", "button__icon");
  icon.setAttribute("viewBox", "0 0 24 24");
  icon.setAttribute("fill", "none");
  icon.setAttribute("stroke", "currentColor");
  icon.setAttribute("stroke-width", "2");
  icon.setAttribute("stroke-linecap", "round");
  icon.setAttribute("stroke-linejoin", "round");
  icon.setAttribute("aria-hidden", "true");
  icon.setAttribute("focusable", "false");
  const path = document.createElementNS(namespace, "path");
  path.setAttribute("d", paths[name]);
  icon.append(path);
  return icon;
}
